import OrderFoodRequest from '@components/order/models/edit/OrderFoodRequest';
import { Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';

interface FoodQuantityNumberProps {
    orderFood: OrderFoodRequest;
}

const FoodQuantityNumber: React.FC<FoodQuantityNumberProps> = observer(({ orderFood }) => {
    return (
        <Typography
            variant='caption'
            fontWeight={600}
            sx={{
                textWrap: "nowrap"
            }}>
            {orderFood.quantity}x
        </Typography>
    )
})

export default FoodQuantityNumber;